import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from 'vue';
import ChecklistsPopoverActions from '@/components/checklists/ChecklistsPopoverActions.vue';
import ChecklistsMainContent from '@/components/checklists/ChecklistsMainContent.vue';
import ChecklistsExpandedSection from '@/components/checklists/ChecklistsExpandedSection.vue';

interface Props {
  onClose: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsPopoverContent',
  props: {
    onClose: { type: Function }
  },
  setup(__props: any) {

const props = __props as {
  onClose: () => void;
};




const currentSection = ref();

function onSectionClick(sectionId: string) {
  currentSection.value = sectionId;
}

function onSectionGoBack() {
  currentSection.value = null;
}

const marginLeft = ref(0);

onMounted(() => {
  const buttonWidth = document.getElementById('checklists-nav-button')?.offsetWidth ?? 0;

  marginLeft.value = buttonWidth / 2 - (document.getElementById('checklists-popover')?.offsetWidth ?? 0) / 2;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "checklists-popover",
    class: "fixed z-[102] mt-2 animate-slideDownAndFade flex w-[400px] select-none flex-col gap-2 rounded-xl border border-subtle bg-card px-6 py-4 shadow-[0_10px_60px_0_rgba(0,0,0,0.16)] outline-0",
    style: _normalizeStyle({ marginLeft: `${marginLeft.value}px` })
  }, [
    _createVNode(ChecklistsPopoverActions, {
      "on-close": props.onClose
    }, null, 8, ["on-close"]),
    (currentSection.value)
      ? (_openBlock(), _createBlock(ChecklistsExpandedSection, {
          key: 0,
          "section-id": currentSection.value,
          "can-go-back": true,
          "on-go-back": onSectionGoBack
        }, null, 8, ["section-id"]))
      : (_openBlock(), _createBlock(ChecklistsMainContent, {
          key: 1,
          "on-section-click": onSectionClick
        }))
  ], 4))
}
}

})